export const MenuRoutes = [
    {
        title:'Home',
        path:'/'
    }, {
        title:'Precious-Market(ERC721)',
        path:'/collectionsv2'
    }, 
    {
        title:'Ecosystem',
        path:'/ecosystem',
        elements:[
//        www.nfttv.cc 
// 1155: issue.nfttv.cc  
// 721：precious.nfttv.cc
            {title:'Issue (ERC1155)',path:'https://issue.nfttv.cc/#/collectionsv2', outLink:true} 
        ]
    }, 
    {
        title:'Studio',
        path:'/studio',
        elements:[ 
            {title:'My Team Wallets',path:'/mywhitelistspagev2'},
            {title:'Create Collection',path:'/createcolletionv2'},
            {title:'Create NFT',path:'/createnftv2'}, 
        ]
    }, 
    {
        title:'About Us',
        path:'https://www.nfttv.cc'
    }
]
